// @flow

export const tooltipEnterDelay: number = 300;
